import { Component, OnInit, inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AuthService, BlockAbstractComponent, PageService, ParserService } from '@gallaghercp/core-frontend';
import { HttpClient } from '@angular/common/http';

@Component({
    selector: 'core-contact-form',
    templateUrl: './block-contact-form.component.html',
    standalone: false,
})
export class BlockContactFormComponent extends BlockAbstractComponent implements OnInit {
    protected override parser: ParserService;
    protected override auth: AuthService;
    protected override pages = inject(PageService);
    protected http = inject(HttpClient);

    contactForm = new FormGroup({
        name: new FormControl('', [Validators.required, Validators.minLength(2)]),
        email: new FormControl('', [Validators.required, Validators.email]),
        message: new FormControl('', [Validators.required, Validators.minLength(3)]),
        submit__confirm: new FormControl(''), // Hidden field to trap bots
    });
    submitting: boolean = false;
    submitSucceeded: boolean = false;
    submitFailed: boolean = false;
    submissionData?: {
        decisionId: number;
        meta: {
            name?: string;
            email?: string;
            message?: string;
            subject?: string;
        };
    };

    constructor() {
        const parser = inject(ParserService);
        const auth = inject(AuthService);

        super(parser, auth);

        this.parser = parser;
        this.auth = auth;
    }

    override ngOnInit() {
        super.ngOnInit();
    }

    onSubmit(): void {
        if (this.contactForm.valid) {
            if (this.contactForm.get('submit__confirm')?.value) {
                return; // Just return and do nothing or handle as a bot submission
            }
            // reset flags on new attempt
            this.submitSucceeded = false;
            this.submitFailed = false;
            this.submitting = true;
            this.submissionData = {
                decisionId: 1,
                meta: {
                    subject: 'Contact Form Submission',
                    name: this.contactForm.get('name')!.value ?? '',
                    email: this.contactForm.get('email')!.value ?? '',
                    message: this.contactForm.get('message')!.value ?? '',
                },
            };

            this.http.post('open-submission', this.submissionData).subscribe(
                () => {
                    this.submitting = false;
                    this.submitSucceeded = true;
                    this.contactForm.reset();
                },
                () => {
                    this.submitting = false;
                    this.submitFailed = true;
                },
            );
        } else {
            this.contactForm.markAllAsTouched();
        }
    }
}
